// Empty vm to access globals in areas not covered by vm

import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(node) {
    console.log('Initializing Placeholder VM');
    const placeholder = new Vue({});
    placeholder.$mount(node);
  }
};
